import FirstLoginModal from './FirstLoginModal'

export default FirstLoginModal
